import { render, staticRenderFns } from "./DocumentsAreaManagement.vue?vue&type=template&id=588482ea&"
import script from "./DocumentsAreaManagement.vue?vue&type=script&lang=ts&"
export * from "./DocumentsAreaManagement.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsAreaManagement.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports